import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  return (
    <nav aria-label="所在位置" className="mb-6">
      <ol className="flex items-center gap-1.5 flex-wrap list-none p-0 m-0">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && (
              <span
                aria-hidden="true"
                className={`text-[13px] select-none ${light ? 'text-background-50/25' : 'text-foreground-300'}`}
              >
                /
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className={`text-[13px] transition-colors whitespace-nowrap ${
                  light
                    ? 'text-background-50/45 hover:text-background-50/75'
                    : 'text-foreground-400 hover:text-foreground-600'
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                aria-current="page"
                className={`text-[13px] whitespace-nowrap ${light ? 'text-background-50/30' : 'text-foreground-400'}`}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}